// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"67f8825f","559":"a6da3058","716":"ea7fe516"}[chunkId] + ".chunk.js";
};